import { EquipoVentas } from '../../../types/vendedor';
import { useRef, useState } from 'react';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';

interface Props {
    equipos?: EquipoVentas[];
}

export function VendedoresList({ equipos }: Props) {
    return (
        <div className="flex-1 min-h-0 flex flex-col gap-y-2 overflow-y-auto">
            {equipos == undefined || equipos.length == 0
            ?
            <div className="my-2">
                <p className="text-center font-semibold text-gray-600 text-sm">No hay equipos</p>
            </div>
            :
            <>
            {equipos?.map((equipo, index) => (
                <EquipoVentaContainer 
                    key={index}
                    equipo={equipo}/>
            ))}
            </>
            }
        </div>
    );
}

interface Props2 {
    equipo: EquipoVentas;
}

export function EquipoVentaContainer({ equipo }: Props2) {
    const numIntegrantes = equipo.segundoIntegrante != null ? 2 : 1;
    return (
        <div className={`h-s[50px] border-2 ${equipo.habilitado ? "border-slate-200 bg-slate-100" : "border-red-200 bg-red-100 opacity-70"} rounded px-2 py-[6px]`}>
            <div className="flex gap-x-1">
                <p className="font-semibold text-[17px]">{equipo.identificador} integrantes: {numIntegrantes}</p>
                {equipo.habilitado == false && (
                <div className="flex items-center gap-x-1">
                    <div className="bg-red-400 rounded-full w-[5px] h-[5px]"></div>
                    {/* <p className="font-semibold text-red-500 text-[17px]">Deshabilitado</p> */}
                    <p className="h-[24px] text-sm border-2 border-red-700 bg-red-100 px-1 rounded-full opacity-100">
                        Deshabilitado
                    </p>
                </div>
                )}
            </div>

            <div className="flex flex-col gap-y-1">
                <div className="flex items-center gap-x-1">
                    <Person2RoundedIcon sx={{ width: 20, height: 20 }}/>
                    <div className="flex gap-x-3 justify-between w-full">
                        <p>{equipo.primerIntegrante.nombre}</p>
                        <p className="h-[24px] text-sm border-2 border-green-700 bg-green-100 px-1 rounded-full">{equipo.primerIntegrante.tipo}</p>
                    </div>
                </div>

                {equipo.segundoIntegrante != null && (
                <div className="flex items-center gap-x-1">
                    <Person2RoundedIcon sx={{ width: 20, height: 20 }}/>
                    <div className="flex gap-x-3 justify-between w-full">
                        <p>{equipo.segundoIntegrante.nombre}</p>
                        <p className="h-[24px] text-sm border-2 border-purple-700 bg-purple-100 px-1 rounded-full">{equipo.segundoIntegrante.tipo}</p>
                    </div>
                </div>
                )}
            </div>
        </div>
    );
}